import { useEffect } from 'react';
import { getScreenName, getWebUserId } from './helper';
import Cookies from 'js-cookie';
import { getCountry } from './ForeignUtils';
import { setDatForAddressRecovery } from './addressUtils';
import { fireEventHandler } from '../components/AddressPage/instrumentation';
import { getGokwikMerchantId, getPublicUrl } from '../appconfig';
import {
  decodeKwickpassKpToken,
  loginSuccessMethod,
} from '../components/LoginModule/utils';
import * as crypto from 'crypto-js';
import { handlePaymentDropOffGokwik } from '../datafetchers/PaymentDropOff';
import { setWebUserIdReact } from './commonUtils';
import { addToCartHandler } from './productAction';
import { getUserCartData } from '../datafetchers/CartWidget';
import { cartDataInitializer } from './CartUtils/CartCookieManger';
import { fireEvent } from './fireEvent';
import { getOrderDetails } from '../datafetchers/OrderSuccessPage';
import { firePurchaseEvent } from './PaymentUtils/purchaseEvent';
import { verifyLoginData } from '../datafetchers/LoginPopup';
import { getWebUserType } from './getWebUserType';
import { fetchUserDetails } from './PaymentUtils/utils';
import { useRouter } from 'next/router';

function useGokwikEvents() {
  const url = getPublicUrl();
  const { fireOrderEvents } = firePurchaseEvent();
  const router = useRouter();

  const handleGokwikEvents = async () => {
    const params = new URLSearchParams(window.location.search);
    const cart_id = params.get('cart_id');
    const skuIds = params.get('sku_id');
    const coupon = params.get('coupon');
    if (cart_id) {
      if (coupon) {
        const cartRequestData = cartDataInitializer();
        await getUserCartData(cartRequestData);
      }
      const encodedWord = crypto.enc.Base64.parse(cart_id); // encodedWord via Base64.parse()
      const decoded = crypto.enc.Utf8.stringify(encodedWord);
      setWebUserIdReact(decoded);
      const gokwikParams = {
        environment: 'production',
        type: 'merchantInfo',
        mid: getGokwikMerchantId(),
        bannerMessages: ['Test'],
        merchantParams: {
          merchantCheckoutId: decoded,
        },
      };
      gokwikSdk.initCheckout(gokwikParams);
    } else if (skuIds) {
      const skuIdsArray = skuIds?.split(',');
      skuIdsArray?.forEach(async (ele) => {
        await addToCartHandler(ele);
      });
    }

    gokwikSdk.on('user-login-initiated', function (userData) {
      fireEvent({
        category: 'user_login_initiated_gokwik',
        support_variable: userData?.phoneNumber,
      });
    });

    gokwikSdk.on('address-selected', function (address) {
      fireEventHandler('selected_address', {
        address_id: address?.address_id,
      });
    });

    gokwikSdk.on('address-add', function (address) {
      const cartItems = Cookies.get('cart_items');
      const supportVariableObj = {
        address_type: address.address_type,
        default_address: 1,
      };

      const fieldAddressEncrypted = setDatForAddressRecovery(address);
      fireEvent({
        category: 'saved_new_address',
        screen_name: getScreenName(),
        valid_address: 1,
        support_variable: supportVariableObj,
        country: getCountry(),
        product_ids: cartItems,
        ...fieldAddressEncrypted,
      });
    });

    gokwikSdk.on('order-complete', async function (order) {
      fireEvent({
        category: 'order_completed_gokwik',
        screen_name: getScreenName(),
        support_variable: order.merchant_order_id,
      });
      const orderData = await getOrderDetails(order.merchant_order_id);
      fireOrderEvents(
        orderData,
        'orderSuccess',
        orderData?.data?.[0]?.payment_mode,
        'order_completed',
      );
      window.location.href =
        `${url}/store/order/${order.merchant_order_id}/success` +
        window.location.search;
    });

    // Make user login
    gokwikSdk.on('customer-attached', async function (customerData) {
      let encryptedToken =
        customerData?.user_data?.token ||
        customerData?.user_data?.customer_token;
      fireEvent({
        category: 'viewed_address_page',
        screen_name: getScreenName(),
        support_variable: encryptedToken.substring(0, 98),
      });
      Cookies.set('lu', encryptedToken, '/');
      Cookies.set('user_guid', encryptedToken, '/');
      Cookies.set('token', encryptedToken, {
        expires: 365,
        path: '/',
      });
      const data = await loginSuccessMethod(encryptedToken);
      fireEvent({
        category: 'OTP_verified',
        screen_name: getScreenName(),
        support_variable: encryptedToken.substring(0, 98),
        parent: data?.user_id,
      });
    });

    // gokwikSdk.on("checkout-initiation-failure", async function (data) {
    //     debugger;
    //     fireEvent({
    //         category: "check_out_initation_failed",
    //         screen_name: getScreenName(),
    //         support_variable: data?.failure_reason,
    //     });
    // });

    // gokwikSdk.on("user-login-successful", async function (data) {
    //     debugger;
    // });

    // Working
    gokwikSdk.on('navigation_payment_options', async function () {
      fireEvent({
        category: 'viewed_payment_page',
        screen_name: getScreenName(),
      });
      handlePaymentDropOffGokwik(getWebUserId());
    });

    // gokwikSdk.on("payment-method-selected", async function (data) {
    //     debugger;
    //     fireEvent({
    //         category: "payment_method_selected_gokwik",
    //         screen_name: getScreenName(),
    //         parent: data?.payment_method,
    //         support_variable: `priority ${data?.priority}`,
    //     });
    // });
    // gokwikSdk.on("payment-failure", async function (data) {
    //     debugger;
    //     fireEvent({
    //         category: "payment_failed_gokwik",
    //         screen_name: getScreenName(),
    //         parent: data?.payment_method,
    //     });
    // });
    // gokwikSdk.on("check-out-close", async function (data) {
    //     debugger;
    //     fireEvent({
    //         category: "gokwik_closed",
    //         screen_name: getScreenName(),
    //     });
    // });

    window.addEventListener('kwikpass-sso', async (event) => {
      console.log(event.detail);
      if (event?.detail?.kpToken) {
        const data = await decodeKwickpassKpToken(event.detail.kpToken);
        if (data?.phone) {
          let api_params = {
            mobile: data.phone,
            web_user_id: getWebUserId(),
          };
          const resData = await verifyLoginData(api_params);
          let encryptedToken = resData?.data;
          Cookies.set('lu', encryptedToken, '/');
          Cookies.set('user_guid', encryptedToken, '/');
          Cookies.set('token', encryptedToken, {
            expires: 365,
            path: '/',
          });
          let userType = getWebUserType();
          let newUser;
          if (Cookies.get('shopper')) newUser = false;
          else newUser = true;
          const params = {
            userType,
            random: new Date().getTime(),
            newUser,
          };
          await fetchUserDetails(params);

          if (window.location.href.includes('/login')) {
            router.back();
          } else {
            window.location.reload();
          }
        }
      }
    });

    window.addEventListener('sso-button-event', (event) => {
      if (event?.detail?.type) {
        Cookies.set('show_sso_tooltip', 'true', {
          expires: 365,
          path: '/',
        });
      }
    });
  };

  useEffect(() => {
    handleGokwikEvents();
  }, []);
}

export default useGokwikEvents;
